import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { useTransition, a } from '@isyc-react/animation/lib';
import clsx from 'clsx';
import "./full-container-relative.modal.style.scss";
export const FullContainerTransform = props => {
  const {
    children,
    show,
    origin
  } = props;
  const transitions = useTransition(show, {
    from: {
      opacity: 0,
      scale: 0
    },
    enter: {
      opacity: 1,
      scale: 1
    },
    leave: {
      opacity: 0,
      scale: 0
    },
    config: {
      mass: 5,
      tension: 2000,
      friction: 200
    }
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, transitions((styles, item) => /*#__PURE__*/React.createElement(React.Fragment, null, item && /*#__PURE__*/React.createElement(a.div, {
    style: _objectSpread(_objectSpread({}, styles), {}, {
      transformOrigin: origin
    })
  }, children))));
};
export const FullContainerScrollable = props => {
  const {
    children,
    className
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('scrollable-content', className)
  }, children);
};